module.exports = __webpack_public_path__ + "static/media/logo145.5e8c690c.png";